import {RecipesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import BenchlingConfig from 'BenchlingConfig';
import {
  ProcedureRunDataEntryMode,
  ProcedureType,
  StudyType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {TypedStudyAdapter} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunAndPlanOverviewTabContents from '../shared/procedure-runs/overview/MultiProcedureRunAndPlanOverviewTabContents';
import ProcedureRunAndPlanOverview from '../shared/procedure-runs/overview/ProcedureRunAndPlanOverview';

export const ProcessDevelopmentStudyAdapter: TypedStudyAdapter = {
  type: StudyType.PROCESS_DEVELOPMENT,

  isFlagEnabled: () => true,

  createCapabilityFeature: RecipesFeature.RECIPES_CREATE_STUDY,

  procedureType: ProcedureType.RECIPE,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: true,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: true,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  isOOTBChartingEnabled: true,

  maxRunsPerStudy: () => BenchlingConfig.STUDIES_MAX_NUM_RUNS_PER_PD_STUDY,

  defaultProcedureRunDataEntryMode: ProcedureRunDataEntryMode.ALL_CONDITION_REPLICATES_TOGETHER,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  creation: {},
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: MultiProcedureRunAndPlanOverviewTabContents,
      design: null,
      execution: ProcedureRunAndPlanOverview,
    },
  },
  review: {},
};
